import React, { useState } from "react";
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import {
  CardElement,
  useElements
} from "@stripe/react-stripe-js";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid2";
import { cardStyle } from "@utils/stripePayments";
import { state, ui } from "../../../../../../../../../interfaces/interfaces";
import env_config from "@src/utilities/config";
import { stripeClient } from ".";
import { serviceAgreement } from "@src/utilities/objects";

const handleSubmit = async (ev: { preventDefault: () => void; }) => {
  ev.preventDefault();
  await stripeClient.createSetupIntent({ description: "Care Plan (Job " + state.JobId + ")", metadata: { "ServiceAgreementId": "0" } }) // setup intent using back-end

  // stripeClient.cardholderName = `${ui.CarePlanBillingContactTitle} ${ui.CarePlanBillingContactFirstName} ${ui.CarePlanBillingContactLastName}`
  // stripeClient.addressLine1 = ui.CarePlanBillingAddressProperty
  // stripeClient.addressLine2 = ui.CarePlanBillingAddressStreet
  // // stripeAPI.addressLine3 = ui.CarePlanBillingAddressLocality ? ui.CarePlanBillingAddressLocality : ""
  // stripeClient.city = ui.CarePlanBillingAddressCity
  // stripeClient.postCode = ui.CarePlanBillingAddressPostcode
  stripeClient.country = "GB"
  stripeClient.email = ui.CarePlanBillingContactEmail

  // null all bank details before caring on
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankName = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankPostcode = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankTown = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankCounty = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankProperty = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankStreet = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitBankLocality = undefined
  serviceAgreement.serviceAgreementPaymentDetails.directDebitEmail = undefined

  serviceAgreement.serviceAgreementPaymentDetails.isEncrypted = false
  serviceAgreement.serviceAgreementPaymentDetails.serviceAgreementBillingFrequencyId = ui.CarePlanPlanDetailsPlanOptionsBillingFrequency?.serviceAgreementBillingFrequencyId ? ui.CarePlanPlanDetailsPlanOptionsBillingFrequency.serviceAgreementBillingFrequencyId : 0
  serviceAgreement.serviceAgreementPaymentDetails.serviceAgreementPaymentTypeId = ui.CarePlanBillingMethodPaymentType?.serviceAgreementPaymentTypeId ? ui.CarePlanBillingMethodPaymentType.serviceAgreementPaymentTypeId : 0
  serviceAgreement.serviceAgreement.serviceAgreementStatusId = 1 // active

  await stripeClient.confirmCardSetup();
}

const StripeCardElement = () => {
  const [succeeded, setSucceeded] = useState(false);
  const [info, setInfo] = useState("Please enter card details and press PAY.");
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [last4, setLast4] = React.useState(null);

  const elements = useElements();
  const card = elements?.getElement(CardElement);

  stripeClient.setInfo = setInfo
  stripeClient.setProcessing = setProcessing
  stripeClient.setSucceeded = setSucceeded
  stripeClient.setError = setError
  stripeClient.card = card || null
  stripeClient.setLast4 = setLast4

  const handleChange = async (event: any) => {
    // Listen for changes in the CardElement
    // and display any errors as the property types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  //build form once created
  return (<>
    <form id="payment-form" onSubmit={(ev) => handleSubmit(ev)}>
      <Grid container spacing={2} >
        <Grid
          size={{
            xs: 12,
            sm: 12
          }}>
          <Paper elevation={2} sx={{ height: 50, padding: 2, paddingRight: "90px" }}>
            <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
            <Button type="submit" style={{ margin: 20, position: "relative", float: "right", right: "-105px", bottom: "45px", marginBottom: "-35px" }}
              disabled={(processing || disabled || succeeded) ? true : false}
              color="primary"
              variant="contained"
            >
              <span id="button-text">
                SELL
              </span>
            </Button>
          </Paper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 12
          }}>
          <Paper elevation={2} sx={{ padding: 2, minWidth: "30em" }}>
            {succeeded ? <Alert severity="success">SUCCESS... Card ...{last4} STORED!</Alert> : error ? <Alert severity="error"> {error}</Alert> : <Alert severity="info">{info}</Alert>}
          </Paper>
        </Grid>
        {env_config.debug &&
          <Grid
            size={{
              xs: 12,
              sm: 12
            }}>
            <Paper elevation={2} sx={{ padding: 1, minWidth: "30em" }}>
              {/* // Generic decline	4000000000000002	card_declined	generic_decline
                // Insufficient funds decline	4000000000009995	card_declined	insufficient_funds
                // Lost card decline	4000000000009987	card_declined	lost_card
                // Stolen card decline	4000000000009979	card_declined	stolen_card
                // Expired card decline	4000000000000069	expired_card	n/a
                // Incorrect CVC decline	4000000000000127	incorrect_cvc	n/a
                // Processing error decline	4000000000000119	processing_error	n/a
                // Incorrect number decline	4242424242424241	incorrect_number	n/a */}
              <Alert severity="success" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Card Accepted - 4242 4242 4242 4242</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Generic Decline - 4000 0000 0000 0002</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Insufficient Funds Decline - 4000 0000 0000 9995</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Lost Card Decline - 4000 0000 0000 9987</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Expired Card Decline - 4000 0000 0000 0069</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Incorrect CVC Decline - 4000 0000 0000 0127</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Processing Error Decline - 4000 0000 0000 0119</Alert>
              <Alert severity="error" sx={{ p: 0, '.MuiAlert-icon': { p: 0 }, '.MuiAlert-message': { p: "2px !important" } }}>Incorrect Number Decline - 4242 4242 4242 4241</Alert>
            </Paper>
          </Grid>
        }
      </Grid>
    </form>
  </>);
}

export default StripeCardElement